import pages from "../web-sh/src/pages";

import authPages from "./auth";
import adminPages from "./admin";

export default {
  ...pages,
  ...authPages,
  ...adminPages
}